import React from 'react';
import { connect } from 'react-redux';
import './TabsContainer.scss';

import { Fire, Tools } from '../../../services'

import { Headerbar, Loader, StatusBubble } from '../../Reusable'

import FadeIn from 'react-fade-in';

const { useLocation } = require('react-router-dom')
const { useHistory } = require('react-router-dom')

interface Props {
  tab: string;
  tabs: any[];
  
  onSelect: (tab: any) => void;
}
const TabsContainer: React.FC<Props> = (props) => {
  const history = useHistory()

  const renderTab = (item, index) => {
    return (
      <div
        key={index}
        className={["tab", item.key === props.tab ? 'selected' : ''].join(' ')}
        onClick={() => props.onSelect(item)}
        >
        { item.status !== undefined &&
          <StatusBubble
            style={{marginRight: 10}}
            type={item.status}
            />
        }
        {item.title}
      </div>
    )
  }

  return (
    <div className="tabs-container">
      <div className="tabs">
        {props.tabs.map(renderTab)}
      </div>
    </div>
  );
}

export default TabsContainer